module.exports = __webpack_public_path__ + "img/cgmp.9b337e57.jpg";